<template>
	<div>
		<!-- 高级查询 -->
		<el-dialog  title="高级查询" :visible.sync="cxdialog" width="900px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="cxtitle" :isdiag="true"></minhead> -->
			<div style="width: 100%;" class="horizontally">
				<el-form  label-width="100px" class="demo-ruleForm">
					<div class="Centerupdown">
						<el-form-item label="单据号:">
							<el-input v-model="serchform.danjh" style="width:215px" ></el-input>
						</el-form-item>

						<el-form-item label="单据状态:" :label-width="formLabelWidth">
							<el-select v-model="serchform.fapzt"  style="width: 215px;">
								<el-option label="待审核" value="0"></el-option>
								<el-option label="已审核" value="1"></el-option>
								<el-option label="待开票" value="2"></el-option>
								<el-option label="开票中" value="3"></el-option>
								<el-option label="已开票" value="4"></el-option>
								<el-option label="开票失败" value="7"></el-option>
								<el-option label="暂不开票" value="8"></el-option>
								<el-option label="已退票" value="9"></el-option>
								<el-option label="无需开票" value="34"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="发票来源:">
							<el-select v-model="serchform.faply"  style="width: 215px;">
								<el-option label="文件导入" value="1"></el-option>
								<el-option label="手工录入" value="2"></el-option>
								<el-option label="客户接口" value="3"></el-option>
								<el-option label="税控同步" value="4"></el-option>
								<el-option label="支付开票" value="5"></el-option>
								<el-option label="扫码开票" value="6"></el-option>
								<el-option label="红冲重开" value="7"></el-option>
                <el-option label="作废重开" value="8"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="发票类型:" :label-width="formLabelWidth">
							<el-select v-model="serchform.faplx"  style="width: 215px;">
								<el-option label="有效" value="1"></el-option>
								<el-option label="停用" value="0"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="发票代码:">
							<el-input v-model="serchform.fapdm" style="width:215px" ></el-input>
						</el-form-item>

						<el-form-item label="发票号码:":label-width="formLabelWidth">
							<el-input v-model="serchform.faphm" style="width:215px" ></el-input>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="购方名称:">
							<el-input v-model="serchform.goufmc" style="width:215px" ></el-input>
						</el-form-item>

						<el-form-item label="购方税号:"  :label-width="formLabelWidth">
							<el-input v-model="serchform.goufsbh" style="width:215px" ></el-input>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="开票日期:">
							<el-date-picker
									v-model="serchform.kaiprq"
									type="daterange"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyyMMdd">
							</el-date-picker>
						</el-form-item>

					</div>

					<div class="Centerupdown">
						<el-form-item label="金     额:">
							<el-input v-model="serchform.hejje" style="width:215px" ></el-input>
						</el-form-item>

						<el-form-item label="税      额:"  :label-width="formLabelWidth">
							<el-input v-model="serchform.hejse" style="width:215px" ></el-input>
						</el-form-item>
					</div>

				</el-form>

			</div>
			<div slot="footer" style="justify-content: right; display: flex;margin-right: 17px;">
				<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="forserchshai" >筛选</div>
				<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="forrestsgai" >重置</div>
				<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="forcloseshai" >关闭</div>
				<!-- <el-button type="primary" plain @click="forserchshai"  style="width: 100px;">筛选</el-button>
				<el-button type="primary" plain  @click="forrestsgai"  style="width: 100px;">重置</el-button>
				<el-button type="primary" plain @click="forcloseshai"  style="width: 100px;">关闭</el-button> -->
			</div>
		</el-dialog>

		<!-- 税控同步 -->
		<el-dialog  title="税控同步"  :visible.sync="sktbdialog"  width="700px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="sktbtitle" :isdiag="true"></minhead> -->
			<div class="Centerhorizontally" style="margin-bottom: 25px;">
				<div v-for="(item, index) in headlist" :key="index" @click="changeindex(index)" class="choosediv">
					<div :style="chooseheadindex == index ? '' : 'opacity: 0.34'">{{ item.title }}</div>
					<div :style="chooseheadindex == index ? 'background: #0080FF' : 'background: white'" class="lineall"></div>
				</div>
			</div>
			<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally" v-if="chooseheadindex == 0">
				<div style="width: 100%;" class="horizontally">
					<el-form  label-width="100px" class="demo-ruleForm" style="margin-right: 100px;">
            <div class="Centerupdown">
              <el-form-item label="税盘编号:" :label-width="formLabelWidth">
                <el-select v-model="sktbform_0.kaipzddm" style="width: 215px;">
                  <el-option v-for="item in kpjList" :key="item.kaipjbh"
                             :label="item.kaipjmc" :value="item.kaipjbh"></el-option>
                </el-select>
              </el-form-item>
            </div>
						<div class="Centerupdown">
							<el-form-item label="发票类型:" :label-width="formLabelWidth">
								<el-select v-model="sktbform_0.faplxdm"  style="width: 215px;">
									<el-option label="电子普票" value="026"></el-option>
									<el-option label="电子专票" value="028"></el-option>
                                    <el-option label="纸质专票" value="004"></el-option>
                                    <el-option label="纸质普票" value="007"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="发票代码:" :label-width="formLabelWidth">
								<el-input v-model="sktbform_0.fapdm" style="width:215px" ></el-input>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="发票号码:" :label-width="formLabelWidth">
								<el-input v-model="sktbform_0.faphm" style="width:215px" ></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
			</div>
			<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally" v-if="chooseheadindex == 1">
				<div style="width: 100%;" class="horizontally">
					<el-form  label-width="100px" class="demo-ruleForm" style="margin-right: 100px;">
            <div class="Centerupdown">
              <el-form-item label="税盘编号:" :label-width="formLabelWidth">
                <el-select v-model="sktbform_1.kaipzddm" style="width: 215px;">
                  <el-option v-for="item in kpjList" :key="item.kaipjbh"
                             :label="item.kaipjmc" :value="item.kaipjbh"></el-option>
                </el-select>
              </el-form-item>
            </div>
						<div class="Centerupdown">
							<el-form-item label="发票类型:" :label-width="formLabelWidth">
								<el-select v-model="sktbform_1.faplxdm"  style="width: 215px;">
									<el-option label="电子普票" value="026"></el-option>
									<el-option label="电子专票" value="028"></el-option>
									<el-option label="纸质专票" value="004"></el-option>
									<el-option label="纸质普票" value="007"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="开票日期:" :label-width="formLabelWidth">
								<el-date-picker
										v-model="sktbform_1.kaiprq"
										type="daterange"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期"
										value-format="yyyyMMdd"
										:picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>
						</div>
					</el-form>
				</div>
			</div>
			<div slot="footer"style="justify-content: right; display: flex;margin-right: 17px;">
				<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="submitSktb" >同步</div>
				<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="resetSktb" >重置</div>
				<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="sktbclose" >关闭</div>
				<!-- <el-button type="primary" plain  @click="submitSktb"  style="width: 100px;">同步</el-button> -->
				<!-- <el-button type="primary" plain  @click="resetSktb"  style="width: 100px;">重置</el-button>
				<el-button type="primary" plain @click="sktbclose"  style="width: 100px;">关闭</el-button> -->
			</div>
		</el-dialog>

		<div class="areacontent" style="margin-top: 16px;">
			<div class="between-line">
				<div class="Centerupdown">
					<!-- <el-button type="primary" @click="sktbButton" plain>
						税控同步
						<i class="el-icon-refresh el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 100px;"  @click="sktbButton" >
						<samp>
						税控同步
						</samp>
					</div>
				<!-- 	<el-button type="primary" @click="excelExport" plain>
						导出
						<i class="el-icon-upload2 el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 80px;margin-left: 16px;"  @click="excelExport" >
						<samp>
						导出
						</samp>
					</div>

				</div>
				<div class="Centerupdown" >
					<el-input style="width: 300px;margin-left: 20px;margin-right: 16px;" placeholder="单据号、购方名称" prefix-icon="el-icon-search" v-model="serchval" clearable @input="forserchcom"></el-input>
					<el-button class="moreserch" type="primary"   @click="forserch" plain  >
						高级查询
						<i class="el-icon-search el-icon--right"></i>
					</el-button>
					<el-dropdown :hide-on-click="false">
				  <span class="el-dropdown-link">
				  <div class="aftericon" style="margin-right: 16px;"><img  src="../../../assets/img/iconshai.png" /></div>
				  </span>
						<el-dropdown-menu slot="dropdown" >
							<el-checkbox-group v-model="checkmeauList">
								<el-dropdown-item  v-for="item in meaulist" ><el-checkbox :label="item" :key="item" @change="clickTitle()">{{item}}</el-checkbox></el-dropdown-item>
							</el-checkbox-group>

						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table :data="tableData" border  @selection-change="handleSelectionChange" style="width: 100%" height="calc(100vh - 295px )"  ref="multipleTable" @sort-change="tableSortChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column v-if="datatitle[0].istrue" fixed prop="danjh" label="单据号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column v-if="datatitle[1].istrue" fixed prop="qiybh" label="企业编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column v-if="datatitle[2].istrue" prop="xiaofmc" label="纳税人名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column v-if="datatitle[3].istrue" prop="fapzt" label="单据状态" align="center"min-width="100" :formatter="this.rowfapzttostring"></el-table-column>
						<el-table-column v-if="datatitle[4].istrue" sortable="custom" prop="faplxdm" label="发票类型" min-width="100" align="center" 
						:formatter="this.rowtofapiao"></el-table-column>
						<el-table-column v-if="datatitle[5].istrue" sortable="custom" prop="fapdm" label="发票代码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column v-if="datatitle[6].istrue" sortable="custom" prop="faphm" label="发票号码" align="left" min-width="160px" 
						show-overflow-tooltip></el-table-column>
						<el-table-column v-if="datatitle[7].istrue" prop="goufmc" label="购方名称"  align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column v-if="datatitle[8].istrue" prop="hejje" label="金额"  align="right" min-width="100">
							<template slot-scope="scope">
							    <span >{{toThousands(Amountformat(scope.row.hejje))}}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="datatitle[9].istrue" prop="hejse" label="税额"  align="right" min-width="100">
							<template slot-scope="scope">
							    <span >{{toThousands(Amountformat(scope.row.hejse))}}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="datatitle[10].istrue" prop="kaiprq" label="开票日期"  align="left" min-width="160px" show-overflow-tooltip >
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									{{stringtostmp(scope.row.kaiprq)}}
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if="datatitle[11].istrue" prop="faply" label="发票来源"  align="center" min-width="100"  :formatter="this.rowfaplytostring"></el-table-column>
						<!--<el-table-column fixed="right" label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small">预览</el-button>
                            </template>
                        </el-table-column>-->
					</el-table>
				</div>
				<div class="lastend">
					<div>当前已勾选<span>{{this.selectCount}}</span>条</div>
					<div>合计金额<span>￥{{toThousands(Amountformat(this.selectJineCount))}}</span></div>
					<div>合计税额<span>￥{{toThousands(Amountformat(this.selectShuieCount))}}</span></div>
				</div>
				<div class="buttompage">
					<el-pagination :key="elementui_page_component_key"
						:current-page="currentpage"   @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 100, 500]"
									 :page-size="pagenum" layout="total, sizes, prev, pager, next, jumper" :total="totalcount"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import axios from "axios";

	export default {
		components: {},
		data() {
			return {
				checkmeauList: ['单据号','企业编号','纳税人名称', '单据状态','发票类型','发票代码','发票号码','购方名称','金额','税额','开票日期','发票来源'],
				checkHeadFiled:["danjh",'qiybh','xiaofmc',"fapzt","faplxdm","fapdm","faphm","goufmc","hejje","hejse","kaiprq","faply"],
				meaulist: ['单据号','企业编号','纳税人名称', '单据状态','发票类型','发票代码','发票号码','购方名称','金额','税额','开票日期','发票来源'],
				datatitle:[
					{prop:"danjh"  ,label:"单据号"	,istrue: true},
					{prop:"qiybh"  ,label:"企业编号"	,istrue: true},
					{prop:"xiaofmc" ,label:"纳税人名称",istrue: true},
					{prop:"fapzt"  ,label:"单据状态"	,istrue: true},
					{prop:"faplxdm",label:"发票类型"	,istrue: true},
					{prop:"fapdm"  ,label:"发票代码"	,istrue: true},
					{prop:"faphm"  ,label:"发票号码"	,istrue: true},
					{prop:"goufmc"  ,label:"购方名称"	,istrue: true},
					{prop:"hejje"  ,label:"金额"		,istrue: true},
					{prop:"hejse"  ,label:"税额"		,istrue: true},
					{prop:"kaiprq"  ,label:"开票日期"	,istrue: true},
					{prop:"faply"  ,label:"发票来源"	,istrue: true}
				],
				formLabelWidth: '150px',
				cxdialog:false,
				sktbdialog:false,
				loaddialog:false,
				page: 1,
				pagenum: 10,
				totalcount: 10,
				serchform:{},
				sktbform_0:{},
				sktbform_1:{},
				tableData: [
				],
				headtitle: ['统计报表', '查询统计'],
				headlist:[
					{
						title: '发票号码查询'
					},
					{
						title: '开票日期查询'
					}
				],
				cxtitle:['高级查询'],
				sktbtitle:['税控同步'],
				serchval: '',
				headIndex:0,
				fpvalidate: {
					faplxdm: [{ required: true, message: '请填写发票类型', trigger: 'blur' }],
					faphm: [{ required: true, message: '请填写发票号码', trigger: 'blur' }],
					fapdm: [{ required: true, message: '请填写发票代码', trigger: 'blur' }]
				},
				datavalidate: {
					kaiprq: [{ required: true, message: '请选择时间', trigger: 'blur' }],
					faplxdm: [{ required: true, message: '请填写发票类型', trigger: 'blur' }],
				},
				selectCount:0,
				selectJineCount:0,
				selectShuieCount:0,
				chooseheadindex:0,
				selectCheckId:[],
				tableHeight:"",
				currentpage:1,
				elementui_page_component_key:"",
				loadyear:"0000",
				loadmonth:"00",
				loadday:"00",
				remainDay:0,
				fapsl:0,
				isSyncExit:false ,//税控同步判断是否要退出
				loadbtnname:"取消",
        kpjList:[],
        defaultkpj:'',
        sort:"desc",
        order:"id"
			};
		},
		created() {
			this.selectRealDoc();
      this.loadKpjList();
		},
		mounted() {
		this.repairtable()
		},
		methods: {
      loadKpjList() {
        this.$https.fetchPost('doc/getKaipjList').then(res => {
          if (res.data.success){
            this.kpjList = JSON.parse(res.data.obj);
            this.kpjList.forEach((item) => {
              if(item.queskpj == '1'){
                this.sktbform.kaipzddm = item.kaipjbh;
                this.defaultkpj = item.kaipjbh;
                return;
              }
            })
          }
        });
      },
			repairtable(){
				this.$nextTick(() => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
					window.onresize = () => {
						this.tableHeight = this.diagheightzhengshutiankai();
						setTimeout(() => {
							this.$refs.multipleTable.doLayout();
						}, 300);
					};
				});
			},
			/* 筛选 */
			forserchshai(){
				this.serchval=""
				this.selectRealDoc();
				this.cxdialog=false

			},
			forcloseshai(){
				this.cxdialog=false
			},
			sktbclose(){
				this.sktbdialog=false
			},
			loadclose(){
				this.isSyncExit=true //退出税控同步
				this.clearSyncParam(); //关闭窗口
			},
			changeindex(index){
				// Object.keys(this.sktbform).map(key => (this.sktbform[key] = ''));
				this.chooseheadindex=index;
			},
			/* 重置高级筛选 */
			forrestsgai(){
				Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
			},
			/* 重置税控同步 */
			resetSktb(){
				Object.keys(this.sktbform_0).map(key => (this.sktbform_0[key] = ''));
				Object.keys(this.sktbform_1).map(key => (this.sktbform_1[key] = ''));
			},
			handleSizeChange(val) {
				this.pagenum = val;
				this.selectRealDoc();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.selectRealDoc();
			},
			/* 高级查询弹框	 */
			forserch(){
				this.cxdialog=true
			},
			sktbButton(){
        this.resetSktb();
				this.sktbdialog=true
			},
			submitSktb(){
        let param;
        if(this.chooseheadindex==0){
          param=JSON.parse(JSON.stringify(this.sktbform_0));
        }else if(this.chooseheadindex==1){
          param=JSON.parse(JSON.stringify(this.sktbform_1));
        }



				if (param.kaiprq){
                    var days = parseInt(parseInt(param.kaiprq[1])-parseInt(param.kaiprq[0]));
                    if(days > 30){
                        this.$message.error("日期范围应在一个月之内");
                        return false;
                    }else {
                        param.kaiprq = param.kaiprq[0] + param.kaiprq[1];
                    }
				}

				this.$https.fetchPost('doc/getSyncInvoice', param).then(res => {
					if (res.data.success){
						this.sktbdialog=false;
						this.selectRealDoc();
					}
				});
			},
			selectRealDoc(){
				let param=JSON.parse(JSON.stringify(this.serchform));
				param.pagenum = this.pagenum;
				param.page = this.page;
				param.serchval=this.serchval;
				if (param.kaiprq){
					param.kaiprq=param.kaiprq[0]+","+param.kaiprq[1];
				}
        param.order = this.order;
        param.sort = this.sort;
				this.$https.fetchPost('real/getRealDocByMap', param).then(res => {
					this.tableData = res.data.obj.data;
					this.totalcount = res.data.obj.count;
				});

			},
			forserchcom(e) {
				this.currentpage=1
				this.elementui_page_component_key++
				this.page=1
				Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
				this.serchval = JSON.parse(JSON.stringify(e));
				this.selectRealDoc();
			},
			//被选中
			handleSelectionChange(e) {
				this.selectCount = 0;
				this.selectJineCount=0;
				this.selectShuieCount=0;
				this.selectCheckId=[];
				e.forEach((item, index) => {
					this.selectCount++;
          this.selectJineCount=this.printFn(parseFloat(this.selectJineCount)+parseFloat(item.hejje));
          this.selectShuieCount= this.printFn(parseFloat(this.selectShuieCount)+parseFloat(item.hejse));
					this.selectCheckId.push(item.id);
				});
			},
      tableSortChange(column, prop, order){
        this.order=column.prop;
        if(column.order){
          this.sort=column.order.replace("ending","");
        }else{
          this.sort="desc";
          this.order="id";
        }
        this.selectRealDoc();
      },
			clickTitle(){
			  
				this.datatitle=JSON.parse(JSON.stringify(this.datatitle).replace(/true/g, 'false'));
				for (let i=0;i<this.checkmeauList.length;i++){
					this.datatitle.find(item => item.label == this.checkmeauList[i]).istrue=true
				}
				this.getheadFiled();
			},
			excelExport(){
				let url = this.$https.baseURL+"excel/getRealDocExcel"; //请求下载文件的地址
				let token=localStorage.getItem('token')

				let param=JSON.parse(JSON.stringify(this.serchform));
				param.pagenum = this.pagenum;
				param.page = this.page;
				param.serchval=this.serchval;
				if(this.selectCheckId.length!=0) {
					param.ids = this.selectCheckId.toString();
				}
				if (param.kaiprq){
					param.kaiprq=param.kaiprq[0]+","+param.kaiprq[1];
				}
				param.headTitle=this.checkmeauList;
				param.headFiled=this.checkHeadFiled.toString();
				if(token != "" & token !=null){
					axios.defaults.headers.common['token']=token
				}
				axios.post(url,param,{responseType:"blob"})
						.then(res => {
							if (!res) return;
							let blob = new Blob([res.data], {
								type: "blob"
							});
							let url = window.URL.createObjectURL(blob);
							let aLink = document.createElement("a");
							aLink.style.display = "none";
							aLink.href = url;
							aLink.setAttribute("download", "查询统计.xls"); // 下载的文件
							document.body.appendChild(aLink);
							aLink.click();
							document.body.removeChild(aLink);
							window.URL.revokeObjectURL(url);
							// let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
							// let objectUrl = URL.createObjectURL(blob);
							// window.location.href = objectUrl;

						})
						.catch(error => {
							this.$message.error(error);
						});

			},
			getheadFiled(){
			  
				this.checkHeadFiled=[];
			  this.checkmeauList=[];
				for (let j=0;j<this.datatitle.length;j++){
				  if(this.datatitle[j].istrue){
            this.checkmeauList.push(this.datatitle[j].label);
          }
				}
        for (let j=0;j<this.datatitle.length;j++) {
          for (let i = 0; i < this.checkmeauList.length; i++) {
            if (this.checkmeauList[i] == this.datatitle[j].label) {
              this.checkHeadFiled.push(this.datatitle[j].prop);
            }
          }
        }
				this.repairtable()
			}
		}
	};
</script>

<style scoped="scoped" lang="less">
	// /deep/.el-dialog__body{
	// 	padding: 0;
	// }

	/deep/.el-table--small td {
		padding: 4px 0;
	}
	/deep/.el-table__body-wrapper {
		min-height: 160px;
	}

	.areatable {
		margin-top: 27px;
	}
	.aftericon:extend(.Centerhorizontally) {
		width: 36px;
		height: 33px;
		background: #ffffff;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
		opacity: 1;
		border-radius: 3px;
		margin-left: 20px;
	}
	.aftericon > img {
		width: 16px;
		height: 16px;
	}
	.areacontent {
		margin-left: 16px;
	}
	.choosediv:extend(.Verticalcenter-line) {
		font-size: 20px;
		color: #0080ff;
		margin-right: 48.5px;
		cursor: pointer;
		margin-left: 48.5px;
	}
</style>
